import { useLessonSettingDetail } from '../../../modules/apis/student/lesson'
import { s_pricing } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

interface Props {
  lessonId: number
}
const LessonInfoTitle = ({ lessonId }: Props) => {
  const { data } = useLessonSettingDetail(lessonId)
  const { t } = useTranslation()

  if (!data) return null
  const { lesson } = data.response
  return (
    <div className="px-[12px flex cursor-pointer flex-row items-center whitespace-nowrap rounded-[5px] py-[10px]">
      <div className="mr-[4px] whitespace-nowrap rounded-[4px] bg-gray-100 px-[6px] py-[2px] text-[12px] font-bold text-gray-800">
        {t(s_pricing.min(lesson.duration))}
      </div>
      <span className="text-[16px] text-black">{data.response.formatted_date}</span>
      <div className="mx-[8px] h-[12px] w-[1px] bg-gray-300"></div>
      <span className="text-[16px] text-black">{data.response.formatted_start_time}</span>
    </div>
  )
}

export default LessonInfoTitle
